import React from 'react';
import unescape from 'unescape';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import I18nLink from '~/components/I18nLink';

@withI18next()
@connect((state) => ({
  currentLanguage: state.language.currentLanguage,
}))
class PhotoTags extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: this.getTagsChunk(),
      expanded: false,
    };
  }

  getTagsChunk() {
    return this.props.tags.slice(0).splice(0, this.props.itemsToShow);
  }

  onExpand = () => {
    if (this.state.expanded) {
      this.setState({
        expanded: false,
        tags: this.getTagsChunk(),
      });
    } else {
      this.setState({
        expanded: true,
        tags: this.props.tags,
      });
    }
  };

  searchCategory = (tags, currentLanguage, categories) =>
    tags
      .filter((tag) => tag.name)
      .map((tag, index) => {
        let href = `/category/${categories[0].category_slug}/${tag.name}`;
        if (currentLanguage !== 'cn') {
          href = `/${currentLanguage}${href}`;
        }
        return (
          <a
            key={`${tag.name}-${index}`}
            className={`ac-tag-item ${Config.getPrefixContent('ac-tag-item')}`}
            href={href}
            target="_blank"
            rel="noreferrer"
          >
            {tag.name}
          </a>
        );
      });

  searchResult = (tags) =>
    tags
      .filter((tag) => tag.name)
      .map((tag, index) => {
        return (
          <React.Fragment key={`${tag.name}-${index}`}>
            <I18nLink href={`/search/${tag.name}?is_tag=true`}>
              <a
                className={`ac-tag-item ${Config.getPrefixContent(
                  'ac-tag-item',
                )}`}
              >
                {unescape(tag.name)}
              </a>
            </I18nLink>
            <style jsx>{''}</style>
          </React.Fragment>
        );
      });

  render() {
    const { tags, expanded } = this.state;
    const isShowMore = this.props.tags.length > this.props.itemsToShow;
    const { categories, t, currentLanguage, hasMaxWidth } = this.props;

    return (
      <div className={`photo-tags ${hasMaxWidth ? 'has-max-width' : ''}`}>
        {Config.isDesignAC()
          ? this.searchCategory(tags, currentLanguage, categories)
          : this.searchResult(tags)}
        {isShowMore && (
          <div
            className={`expand-tags ${
              Config.isIllustAC()
                ? 'ill-btn-show-more'
                : Config.getPrefixContent('color-ac-primary')
            }`}
            onClick={this.onExpand}
          >
            {expanded ? t('show_less') : t('show_more')}
          </div>
        )}
        <style jsx global>
          {`
            .photo-tags {
              display: flex;
              flex-wrap: wrap;
              margin-top: 10px;
              align-items: center;
              width: 100%;
            }
            .photo-tags .ac-tag-item {
              padding: 8px 10px;

              ${Config.isIllustAC()
                ? `padding: 8px 16px;
                border: 1px solid #7A7A7A;
                border-radius: 40px;
                margin-left: 8px;
                margin-bottom: 8px;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #170507;`
                : `background: #ecf1f4;
              border-radius: 4px;
              margin: 3px 6px;
              border-radius: 2px;
              color: #1b2833;`}
            }
            .photo-tags .ac-tag-item:hover {
              background-color: #f2f3f4;
            }
            .photo-tags .design_ac-tag-item:hover {
              border-color: #ffa823;
            }

            .photo-tags .photo_ac-tag-item:hover {
              border-color: #509bdc;
            }
            .photo-tags .sil_ac-tag-item:hover {
              border-color: #41b9b8;
            }
            .photo-tags .expand-tags {
              padding: 8px 10px;
              margin: 3px 6px;
              color: #ffa823;
              cursor: pointer;
            }

            .photo-tags .expand-tags:hover {
              opacity: 0.8;
            }

            .ill-btn-show-more {
              color: #170507 !important;
              font-weight: 700;
              font-size: 14px;
              line-height: 16px;
            }
          `}
        </style>
      </div>
    );
  }
}

PhotoTags.propTypes = {
  tags: PropTypes.array,
  itemsToShow: PropTypes.number,
  hasMaxWidth: PropTypes.bool,
};
PhotoTags.defaultProps = {
  tags: [],
  itemsToShow: 10,
  hasMaxWidth: false,
};
export default PhotoTags;
